import React from 'react';
import SplitViewFieldsGrid from '../../../../components/generic/SplitViewFieldsGrid';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import { normalizeFileName } from '../../../../components/ui/utils/fileNameEncoding';

const SupplierDetailsTab = ({ 
  selectedRecord, 
  selectedRecordFiles, 
  config, 
  fields 
}) => {
  const { theme } = useTheme();

  return (
    <div 
      className="p-4 flex-1 overflow-y-auto advanced-table-scroll"
      style={{ 
        scrollbarWidth: 'thin',
        minHeight: 0,
        maxHeight: '100%'
      }}
    >
      <div className="grid grid-cols-1 gap-4">
                <SplitViewFieldsGrid
          selectedRecord={selectedRecord}
          fields={fields}
          config={config}
          layout="boxed"
        />
        
        {/* File Attachments Section - Disabled for suppliers */}
        {config.features?.fileAttachments && selectedRecordFiles && selectedRecordFiles.length > 0 && (
          <div>
            <div className="flex items-center gap-2 mb-3">
              <svg className="w-5 h-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
              </svg>
              <div className={cn("text-sm font-semibold", theme.text.primary)}>
                File Attachments ({selectedRecordFiles.length})
              </div>
            </div>
            <div className="space-y-2 max-h-48 overflow-y-auto">
              {selectedRecordFiles.map((file, index) => (
                <div key={index} className={cn("flex items-center gap-3 p-3 rounded-lg border", theme.colors.background, theme.border.subtle)}>
                  <svg className="w-4 h-4 text-blue-500 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                  </svg>
                  <div className="flex-1 min-w-0">
                    <div className={cn("text-sm font-medium truncate", theme.text.primary)}>
                      {normalizeFileName(file.fileName || '')}
                    </div>
                    <div className={cn("text-xs", theme.text.secondary)}>
                      {file.fileSize ? `${(file.fileSize / 1024 / 1024).toFixed(2)} MB` : 'Unknown size'} • {file.fileType || 'Unknown type'}
                    </div>
                  </div>
                  <a 
                    href={`/api/file-attachment/download/${file.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={cn("text-xs px-3 py-1 rounded-md transition-colors", theme.colors.primary, theme.text.inverse, "hover:opacity-80")}
                  >
                    Download
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SupplierDetailsTab;
